module.exports = __webpack_public_path__ + "media/Icons/NoImageWhiteBG-724e6d2c.svg";